<template>
    <div>
        <div v-if="typeLabel" class="d-flex align-items-center mb-3">
            <h5 class="mb-0 text-nowrap">{{ typeLabel }}</h5>

            <div v-if="property.serviceLevel == 'W'" style="width:22; height:22px;" class="ms-2 ms-sm-3 clickable" @click="showMarquisModal=true">
                <marquis-circle-icon/>
            </div>
        </div>

        <property-card-icons class="small text-muted" :property="property" :useBedsCount="true" :includeBedroomsCount="true"/>
        <marquis-modal v-if="showMarquisModal" @close="showMarquisModal=false"/>
    </div>
</template>

<script type="text/javascript">
    import PropertyCardIcons from '@/components/Content/Public/Properties/Cards/Parts/Icons.vue';
    import MarquisCircleIcon from '@/assets/logos/marquis-circle-icon.svg.vue';
    import MarquisModal from '@/components/Content/Public/Properties/MarquisModal.vue';

    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';

    export default {
        components: {
            PropertyCardIcons,
            MarquisCircleIcon,
            MarquisModal,
            ...CommonComponents,
        },

        data() {
            return {
                showMarquisModal: false,
            };
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },
        },

        computed: {

            typeLabel() {
                let type = 'House';
                if ((this.property) && (this.property.type) && (this.property.type.name)) {
                    type = this.property.type.name;
                }
                if ((this.property) && (this.property.serviceLevel == 'W')) {
                    return type+' hosted by StayMarquis';
                }
                
                return type+' hosted by owner';
            },
            
        },
    };

</script>
